/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
    Avatar, List, ListItemText, Tooltip,
} from 'appkit-react';

import { ModuleIdEnum } from 'constants';
import logo from 'assets/images/pwc-logo.svg';
import '../styles/AppBar.scss';
import ReportsModal from '../ReportsModal/ReportsModal';

const AppBarComponent = ({
    history, tenantVar, showReportMenu, dataReconActiveMenuOption, showDataReconMenus,
    hasOutLine, onMouseDown, onBlur, onLogout, onChangeDataReconMenu,
    navigateToLandingPage, leftNavigationItemsVar, userInfo,
    toggleOrganization, tenantName, module, onConfigureDataSource,
    showCrossReportConfigMenu, initials,
}) => (
    <div
        className="normal-header-container a-secondary-header-container-background-color"
    >
        <nav
            onMouseDown={onMouseDown}
            onBlur={onBlur}
            className={`a-header-wrapper justify-content-between ${hasOutLine ? 'a-header-wrapper-no-outline' : ''
            }`}
            role="presentation"
        >
            <div className="a-brand-container">
                <img
                    src={logo}
                    className="brand-logo"
                    alt="logo Icon"
                    onClick={navigateToLandingPage}
                />
                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                <div className="brand-name" onClick={navigateToLandingPage}>
                    Report Inspector
                </div>
                <div className="a-divider-full" />

                {showReportMenu && (
                    <span
                        className="font-weight-medium text-nowrap nav-menu-select"
                        style={{ marginLeft: '1rem ' }}
                    >
                        <ReportsModal />
                    </span>
                )}
                {showDataReconMenus && (
                    <>
                        <span
                            className={`font-weight-medium text-nowrap ${dataReconActiveMenuOption === 'home' ? 'appbar-header-menu-active' : 'appbar-header-menu-inactive'}`}
                            onClick={() => onChangeDataReconMenu('home')}
                            role="presentation"
                        >
                            Home
                        </span>
                        <span
                            className={`font-weight-medium text-nowrap ${dataReconActiveMenuOption === 'projects'
                                ? 'appbar-header-menu-active'
                                : 'appbar-header-menu-inactive'}`}
                            style={{ marginLeft: '1.5rem', cursor: 'pointer' }}
                            onClick={() => onChangeDataReconMenu('projects')}
                            role="presentation"
                        >
                            Projects
                        </span>
                    </>
                )}
            </div>
            {userInfo && (
                <div className="a-actions-container">
                    {module === ModuleIdEnum.CROSSREPORTVALIDATION && showCrossReportConfigMenu && (
                        <span
                            className="appkiticon icon-configuration-outline"
                            style={{ fontSize: '1.5rem' }}
                        >
                            <span
                                className="font-weight-medium text-nowrap"
                                style={{
                                    marginRight: '1.5rem',
                                    fontSize: '0.85rem',
                                    fontWeight: 300,
                                }}
                                onClick={onConfigureDataSource}
                                role="presentation"
                            >
                                Configure data source
                            </span>
                        </span>
                    )}
                    <Tooltip
                        content={(
                            <span>
                                <List>
                                    <ListItemText>
                                        <div style={{ height: '2.5rem' }}>
                                            <p className="primary-text">{userInfo.fullName.toUpperCase()}</p>
                                            <p className="secondary-text">{tenantName}</p>
                                        </div>
                                    </ListItemText>
                                </List>
                                <div style={{ height: '0.01rem' }}>
                                    <hr
                                        style={{ borderWidth: '2px', borderColor: '#DEDEDE' }}
                                    />
                                </div>
                                <div style={{ color: '#616161', marginTop: '0.3rem', marginLeft: '0.5rem' }}>
                                    Organizations
                                </div>
                                <List>
                                    {
                                        userInfo.userTenants.filter(item => item.tenantId !== tenantVar).map(({ name, tenantId }) => (
                                            <ListItemText
                                                key={tenantId}
                                                onClick={
                                                    () => {
                                                        toggleOrganization(tenantId, name);
                                                    }
                                                }
                                            >
                                                {name}
                                            </ListItemText>
                                        ))
                                    }
                                </List>
                                <div style={{ height: '0.01rem' }}>
                                    <hr
                                        style={{ borderWidth: '2px', borderColor: '#DEDEDE' }}
                                    />
                                </div>
                                <List>
                                    <ListItemText onClick={
                                        () => {
                                            history.push(
                                                {
                                                    pathname: '/my-profile',
                                                    state: {
                                                        tenantVar,
                                                    },
                                                },
                                            );
                                            leftNavigationItemsVar([]);
                                        }
                                    }
                                    >
                                        My Profile
                                    </ListItemText>
                                    {userInfo.iamRole === 'ADMIN' && userInfo.iamTenant.tenantId === tenantVar && (
                                        <ListItemText onClick={
                                            () => {
                                                history.push(
                                                    {
                                                        pathname: '/user-management',
                                                        state: {
                                                            tenantVar,
                                                        },
                                                    },
                                                );
                                                leftNavigationItemsVar([]);
                                            }
                                        }
                                        >
                                            User Management
                                        </ListItemText>
                                    )}
                                    <ListItemText onClick={onLogout}>Logout</ListItemText>
                                </List>
                            </span>
                        )}
                        trigger="click"
                        refClassName="a-account-info"
                        className="a-account-options"
                        clickToClose
                        placement="bottom-end"
                        tooltipTheme="light"
                        style={{ width: '270px' }}
                    >
                        <div
                            className="true-comply-appnavbar__avatar"
                        >
                            <Avatar
                                size="default"
                                style={{ width: '2rem', height: '2rem' }}
                                label={initials}
                            />
                        </div>
                    </Tooltip>
                </div>
            )}
        </nav>
    </div>
);

export default AppBarComponent;
